import { store } from "src/store/store";
import { getThemeSource } from "src/duck/selectors";
import getIsDarkMode from "src/styling/getIsDarkMode";
import environment from "src/utils/environment";

const path = window.require("path");
const fs = window.require("fs");
const { app } = window.require("@electron/remote");
const { appName, publicPath } = environment;

function getAnimationData(animationName, { directory = "animations" } = {}) {
  const appPath = app.getAppPath();
  let result;

  const relativePath = path.join(appName, directory);
  const isDarkMode = getIsDarkMode();
  const directoryPath = path.join(appPath, relativePath);

  const animationPath = path.join(directoryPath, animationName);
  if (fs.existsSync(animationPath)) {
    result = window.require(animationPath);
  }

  if (!isDarkMode && result == null) {
    const lightAnimationDataPath = path.join(
      directoryPath,
      `light-${animationName}`
    );
    if (fs.existsSync(lightAnimationDataPath)) {
      result = window.require(lightAnimationDataPath);
    }
  }

  if (isDarkMode && result == null) {
    const darkAnimationDataPath = path.join(
      directoryPath,
      `dark-${animationName}`
    );
    if (fs.existsSync(darkAnimationDataPath)) {
      result = window.require(darkAnimationDataPath);
    }
  }

  return result;
}

function getBrowserAnimationPath(
  animationName,
  { directory = "animations" } = {},
  browserProps = { useTheme: true }
) {
  const { useTheme } = browserProps;

  let isDarkMode;
  const themeSource = getThemeSource(store.getState());
  if (themeSource === "system") isDarkMode = getIsDarkMode();
  else isDarkMode = themeSource === "dark";

  const theme = useTheme ? (isDarkMode ? "dark-" : "light-") : "";
  const path = `${publicPath}/${appName}/${directory}/${theme}${animationName}`;
  return path;
}

export default environment.isBrowser
  ? getBrowserAnimationPath
  : getAnimationData;
